import React, { useEffect, useMemo, useState } from 'react';
import { useColorScheme } from 'react-native';
import config from 'react-native-ultimate-config';
import ThemeContext from '.';
import getTheme from '../10-parts';
import useDeviceType from '../hooks/useDeviceType';
import useDimensions from '../hooks/useDimensions';
import selectBasedOnThemeID from '../utils/selectBasedOnThemeID';
import { isValidThemeID } from './utils';
const ThemeProvider = ({ theme, children, ...rest }) => {
    const colorScheme = useColorScheme();
    const configTheme = isValidThemeID(config.DEFAULT_THEME)
        ? config.DEFAULT_THEME
        : 'light';
    const [selectedTheme, setSelectedTheme] = useState(theme || configTheme);
    useEffect(() => {
        if (theme) {
            // When theme prop is given, then that
            // should take the highest priority over
            // colorScheme or any other influencers
            setSelectedTheme(theme);
        }
        else {
            // Automatically switch the Theme based on
            // Native color scheme only if theme is not provided
            // RN ColorSchemeName includes "unspecified" — only light/dark drive theme
            const scheme = isValidThemeID(colorScheme)
                ? colorScheme
                : configTheme;
            setSelectedTheme(scheme);
        }
    }, [colorScheme, theme, configTheme]);
    const [dimensions] = useDimensions();
    const deviceType = useDeviceType();
    const value = useMemo(() => ({
        theme: getTheme(selectedTheme),
        dimensions,
        deviceType,
        select: selectBasedOnThemeID(selectedTheme),
        change: setSelectedTheme,
    }), [selectedTheme, dimensions, deviceType]);
    return (React.createElement(ThemeContext.Provider, { value: value, ...rest }, typeof children === 'function' ? children(value) : children));
};
export default ThemeProvider;
